import React from 'react'
import ContentLoader from 'react-content-loader'
import classes from './BlogLoader.module.css'

export const BlogContentLoader = () => {
    return (
        <ContentLoader className={classes.loader}>
            <rect width={'100%'} height={400} />
            {[...Array(3)].map((_, idx) => {
                const rectStart = 420 + 130 * idx
                return (
                    <>
                        <rect width={'100%'} height={20} y={rectStart} />
                        <rect width={'100%'} height={20} y={rectStart + 30} />
                        <rect width={'100%'} height={20} y={rectStart + 60} />
                        <rect width={'90%'} height={20} y={rectStart + 90} />
                    </>
                )
            })}
        </ContentLoader>
    )
}

export const BlogTitleLoader = () => (
    <ContentLoader>
        <rect height={40} width={300} />
        <circle cx="25" cy="98" r="25" y={74} />
        <rect height={15} x={70} y={78} width={150} />
        <rect height={15} x={70} y={100} width={120} />
    </ContentLoader>
)
